'use client';

import { useTranslations } from 'next-intl';
import Image from 'next/image';

const TermsOfUse = () => {
    const t = useTranslations('termsOfUse');

    const mergedIntroductionContent = `
    ${t.raw('sub-title.part1')}
    ${t.raw('sub-title.part2')}
    ${t.raw('sub-title.part3')}
    ${t.raw('sub-title.part4')}
    ${t.raw('sub-title.part5')}
`;
    return (
        <div className="flex flex-col min-h-screen">
            {/* Hero Section with Background Image */}
            <section className="relative h-[300px] flex items-center justify-center">
                <div
                    className="absolute inset-0"
                >
                    <Image
                        src="/images/Privacy-policy-banner.png"
                        alt="Privacy Policy Background"
                        fill
                        className="object-cover bg-center bg-no-repeat"
                        priority
                    />
                    <div className="absolute inset-0 bg-black/50" />
                </div>
                <h1 className="text-5xl font-bold text-white relative z-10">
                    {t('hero')}
                </h1>
            </section>

            {/* Content Section */}
            <section className="bg-[#1a1b2b] min-h-screen px-4 py-24">
                <div className="max-w-7xl mx-auto space-y-8">
                    {/* Header */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title')}</h2>
                    </div>
                    {/* Introduction */}
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: mergedIntroductionContent }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title.part6') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title.part7') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title.part8') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title.part9') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title.part10') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title.part11') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title.part12') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title.part13') }}
                    />
                    {/* Services */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title2')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title2.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title2.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title2.part3') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title2.part4') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title2.part5') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title2.part6') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title2.part7') }}
                    />
                    {/* Intellectual Property Rights */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title3')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title3.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title3.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title3.part3') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title3.part4') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title3.part5') }}
                    />
                    {/* COMMUNICATIONS */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title4')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title4.part1') }}
                    />
                    {/* USER REGISTRATION */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title5')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title5.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title5.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title5.part3') }}
                    />
                    {/* FEES AND PAYMENT */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title6')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part3') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part4') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part5') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part6') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part7') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part8') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part9') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part10') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title6.part11') }}
                    />
                    {/* USER CONTENT */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title7')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title7.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title7.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title7.part3') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title7.part4') }}
                    />
                    {/* INTERACTIONS WITH OTHER USERS */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title8')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title8.part1') }}
                    />
                    {/* THIRD-PARTY WEBSITES AND CONTENT */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title9')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title9.part1') }}
                    />
                    {/* ACCEPTABLE USE POLICY */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title10')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part3') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part4') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part5') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part6') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part7') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part8') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part9') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part10') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part11') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part12') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part13') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part14') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part15') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part16') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part17') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part18') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part19') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part20') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part21') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part22') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part23') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part24') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part25') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part26') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part27') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part28') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part29') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part30') }}
                    />     <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part31') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title10.part32') }}
                    />

                    {/* TERMINATION */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title11')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title11.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title11.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title11.part3') }}
                    />
                    {/* GOVERNING */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title12')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title12.part1') }}
                    />
                    {/* DISPUTE RESOLUTION */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title13')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title13.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title13.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title13.part3') }}
                    />
                    {/* DISCLAIMERS */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title14')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title14.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title14.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title14.part3') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title14.part4') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title14.part5') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title14.part6') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title14.part7') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title14.part8') }}
                    />
                    {/*  LIMITATION OF LIABILITY */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title15')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title15.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title15.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title15.part3') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title15.part4') }}
                    />
                    {/*  ASSUMPTION OF RISK */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title16')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part3') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part4') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part5') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part6') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part7') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part8') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part9') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part10') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part11') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part12') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part13') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part14') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part15') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part16') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part17') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part18') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part19') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part20') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part21') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part22') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title16.part23') }}
                    />
                    {/*  INVESTIGATIONS */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title17')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title17.part1') }}
                    />
                    {/*  INDEMNIFICATION */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title18')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title18.part1') }}
                    />
                    {/*  RELEASE */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title19')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title19.part1') }}
                    />
                    {/*  MISCELLANEOUS */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title20')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title20.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title20.part2') }}
                    />
                    {/*   Additional Terms Applicable to Mobile Devices */}
                    <div className="space-y-8">
                        <h2 className="text-xl font-bold text-white">{t('title21')}</h2>
                    </div>
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part1') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part2') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part3') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part4') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part5') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part6') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part7') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part8') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part9') }}
                    />
                    <div>
                        <p
                            className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                            dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part10') }}
                        />
                        <p
                            className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                            dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part11') }}
                        />
                        <p
                            className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                            dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part12') }}
                        />
                        <p
                            className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                            dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part13') }}
                        />
                        <p
                            className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                            dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part14') }}
                        />
                    </div>

                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part15') }}
                    />
                    <p
                        className="text-white text-base [&_a]:text-[#f88523] [&_a]:no-underline [&_a:hover]:underline"
                        dangerouslySetInnerHTML={{ __html: t.raw('sub-title21.part16') }}
                    />
                </div>
            </section>
        </div>
    );
};

export default TermsOfUse;
